import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { WhatsappLogo } from "@phosphor-icons/react";

export default function PromoBanner() {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-20 bg-[#FFD700] relative overflow-hidden" data-testid="promo-banner">
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 20px, #000 20px, #000 21px)" }} />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-light text-black tracking-tight mb-4">
            {t.promo.title}
          </h2>
          <p className="text-black/70 text-base md:text-lg font-light mb-8 max-w-2xl mx-auto">
            {t.promo.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/19732883496"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-black text-[#FFD700] font-medium uppercase tracking-wider text-sm hover:bg-black/80 transition-all duration-300"
              data-testid="promo-whatsapp-btn"
            >
              <WhatsappLogo size={20} weight="fill" />
              {t.promo.ctaWhatsapp}
            </a>
            <a
              href="tel:9732883496"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-black text-black font-medium uppercase tracking-wider text-sm hover:bg-black hover:text-[#FFD700] transition-all duration-300"
              data-testid="promo-call-btn"
            >
              {t.promo.ctaCall}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
